export class AccountingAccountType {
    readonly name: string;
    readonly id: string;
    readonly type: "booking" | "bill";

    private constructor(id: string, name: string, type: "booking" | "bill") {
        this.id = id;
        this.name = name;
        this.type = type;
    }

    //booking accounts
    public static PERM_REVENUE = new AccountingAccountType(
        "4000",
        "4000 - Perm Revenue",
        "booking"
    );
    public static LOCUM_REVENUE = new AccountingAccountType(
        "4100",
        "4100 - Locum Revenue",
        "booking"
    );
    public static CONTRACT_REVENUE = new AccountingAccountType(
        "4200",
        "4200 - Contract Revenue",
        "booking"
    );
    public static MEMBERSHIP_REVENUE = new AccountingAccountType(
        "4300",
        "4300 - Membership Revenue",
        "booking"
    );
    public static JOB_POSTING_REVENUE = new AccountingAccountType(
        "4400",
        "4400 - Job Posting Revenue",
        "booking"
    );

    //bill accounts
    public static PERM_REFERRAL_EXPENSE = new AccountingAccountType(
        "5080",
        "5080 - Perm Referral Expense",
        "bill"
    );
    public static PERM_SPONSORED_EXPENSE = new AccountingAccountType(
        "5081",
        "5081 - Perm Sponsored Expense",
        "bill"
    );
    public static PERM_MANAGEMENT_EXPENSE = new AccountingAccountType(
        "5085",
        "5085 - Perm Management Expense",
        "bill"
    );
    public static PERM_SUBMISSION_EXPENSE = new AccountingAccountType(
        "5095",
        "5095 - Perm Submission Expense",
        "bill"
    );
    public static PERM_INTERVIEW_EXPENSE = new AccountingAccountType(
        "5096",
        "5096 - Perm Interview Expense",
        "bill"
    );
    public static LOCUM_CONTRACTOR_PAYROLL = new AccountingAccountType(
        "5100",
        "5100 - Locum Contractor Payroll",
        "bill"
    );
    public static LOCUM_TRAVEL_AND_EXPENSE = new AccountingAccountType(
        "5140",
        "5140 - Locum Travel & Expense",
        "bill"
    );
    public static LOCUM_REFERRAL_EXPENSE = new AccountingAccountType(
        "5180",
        "5180 - Locum Referral Expense",
        "bill"
    );
    public static LOCUM_MANAGEMENT_EXPENSE = new AccountingAccountType(
        "5185",
        "5185 - Locum Management Expense",
        "bill"
    );
    public static LOCUM_SUBMISSION_EXPENSE = new AccountingAccountType(
        "5195",
        "5195 - Locum Submission Expense",
        "bill"
    );
    public static LOCUM_INTERVIEW_EXPENSE = new AccountingAccountType(
        "5196",
        "5196 - Locum Interview Expense",
        "bill"
    );
    public static CONTRACT_CONTRACTOR_PAYROLL = new AccountingAccountType(
        "5200",
        "5200 - Contract Contractor Payroll",
        "bill"
    );
    public static CONTRACT_TRAVEL_AND_EXPENSE = new AccountingAccountType(
        "5240",
        "5240 - Contract Travel & Expense",
        "bill"
    );
    public static CONTRACT_REFERRAL_EXPENSE = new AccountingAccountType(
        "5280",
        "5280 - Contract Referral Expense",
        "bill"
    );
    public static CONTRACT_MANAGEMENT_EXPENSE = new AccountingAccountType(
        "5285",
        "5285 - Contract Management Expense",
        "bill"
    );
    public static CONTACT_SUBMISSION_EXPENSE = new AccountingAccountType(
        "5295",
        "5295 - Contract Submission Expense",
        "bill"
    );
    public static CONTRACT_INTERVIEW_EXPENSE = new AccountingAccountType(
        "5296",
        "5296 - Contract Interview Expense",
        "bill"
    );
    public static MARKETING_EXPENSE = new AccountingAccountType(
        "6085",
        "6085 - Marketing Expense",
        "bill"
    );

    public static bookingAsArray = () => [
        AccountingAccountType.PERM_REVENUE,
        AccountingAccountType.LOCUM_REVENUE,
        AccountingAccountType.CONTRACT_REVENUE,
        AccountingAccountType.MEMBERSHIP_REVENUE,
        AccountingAccountType.JOB_POSTING_REVENUE,
    ];

    public static billAsArray = () => [
        AccountingAccountType.PERM_REFERRAL_EXPENSE,
        AccountingAccountType.PERM_SPONSORED_EXPENSE,
        AccountingAccountType.PERM_MANAGEMENT_EXPENSE,
        AccountingAccountType.PERM_SUBMISSION_EXPENSE,
        AccountingAccountType.PERM_INTERVIEW_EXPENSE,
        AccountingAccountType.LOCUM_CONTRACTOR_PAYROLL,
        AccountingAccountType.LOCUM_TRAVEL_AND_EXPENSE,
        AccountingAccountType.LOCUM_REFERRAL_EXPENSE,
        AccountingAccountType.LOCUM_MANAGEMENT_EXPENSE,
        AccountingAccountType.LOCUM_SUBMISSION_EXPENSE,
        AccountingAccountType.LOCUM_INTERVIEW_EXPENSE,
        AccountingAccountType.CONTRACT_CONTRACTOR_PAYROLL,
        AccountingAccountType.CONTRACT_TRAVEL_AND_EXPENSE,
        AccountingAccountType.CONTRACT_REFERRAL_EXPENSE,
        AccountingAccountType.CONTRACT_MANAGEMENT_EXPENSE,
        AccountingAccountType.CONTACT_SUBMISSION_EXPENSE,
        AccountingAccountType.CONTRACT_INTERVIEW_EXPENSE,
        AccountingAccountType.MARKETING_EXPENSE,
    ];
}
